/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type LabReportDtoLabTestMaterial =
  (typeof LabReportDtoLabTestMaterial)[keyof typeof LabReportDtoLabTestMaterial];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LabReportDtoLabTestMaterial = {
  SPUTUM_FROM_THE_AIRWAYS: 'SPUTUM_FROM_THE_AIRWAYS',
  OTHER_MATERIAL_FROM_THE_AIRWAYS: 'OTHER_MATERIAL_FROM_THE_AIRWAYS',
  OTHER_MATERIAL: 'OTHER_MATERIAL',
} as const;
